import { ActionSelection } from '../../../types';
import { IStudentRow } from 'api-paths-cas';
import { type IAlertDialogData } from 'shared-components';

export const handleUpdateVisaSupportAction = async (
  action: ActionSelection,
  visibleStudents: IStudentRow[],
  selectedRows: string[],
  assignVisaSupport: (uni: string, studentNo: string, intakeId: string, offerId: string) => void,
  unassignVisaSupport: (uni: string, studentNo: string, intakeId: string, offerId: string) => void,
  showActionWarning: (modalData: IAlertDialogData) => void,
) => {
  const selectedStudent = visibleStudents.find(value => value.p_key === selectedRows[0]);

  const handleAction = () => {
    if (!selectedStudent) {
      return false;
    }

    const [uni, studentNo, intakeId, offerId] = selectedStudent.p_key.split('#');

    if (action === ActionSelection.ASSIGN_VISA_SUPPORT) {
      return assignVisaSupport(uni, studentNo, intakeId, offerId);
    }
    return unassignVisaSupport(uni, studentNo, intakeId, offerId);
  };

  const studentNo = selectedStudent?.p_key?.split('#')?.[1];
  const studentCard = `${selectedStudent?.given_name} ${selectedStudent?.surname} (${studentNo})`;
  const description =
    action === ActionSelection.ASSIGN_VISA_SUPPORT
      ? `Do you wish to assign the following student to the Enroly Visa Support Service: ${studentCard}?`
      : `Do you wish to unassign the following student from the Enroly Visa Support Service: ${studentCard}?`;

  const title = action === ActionSelection.ASSIGN_VISA_SUPPORT ? 'Assign visa support?' : 'Unassign from visa support?';

  const confirmationButtonText = action === ActionSelection.ASSIGN_VISA_SUPPORT ? 'Assign' : 'Unassign';

  showActionWarning({
    modalTitle: title,
    descriptionText: description,
    confirmationButtonText,
    clickAction: () => handleAction(),
  });
};
